import areasNavigationController from './areasNavigationController';


const AreasNavigationComponent = {
    template: require('./areasNavigationView.html'),
    controller: areasNavigationController
};

export default AreasNavigationComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/components/areasNavigation/areasNavigationComponent.js